<!--
 * @Description: 教职工详情 发表论文
 * @Author: 张天伟
 * @Date: 2023-03-08 17:11:23
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:54:01
-->

<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="发表论文名称" label-align="right" align="left" width="120px" span="2">{{item.fblwmc}}</el-descriptions-item>
      <el-descriptions-item label="发表日期" label-align="right" align="left" width="120px" span="2">{{item.fbrq}}</el-descriptions-item>
      <el-descriptions-item label="刊物名称" label-align="right" align="left" width="120px" span="2">{{item.kwmc}}</el-descriptions-item>
      <el-descriptions-item label="刊物等级" label-align="right" align="left" width="120px" span="2">{{item.kwdjbt}}</el-descriptions-item>
      <el-descriptions-item label="字数" label-align="right" align="left" width="120px" span="2">{{item.zs}}</el-descriptions-item>
      <el-descriptions-item label="署名次序" label-align="right" align="left" width="120px" span="2">{{item.smcx}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongfabiaolunwen/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
